var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.696,
    height: 33.998,
    viewBox: "0 0 23.696 33.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_509_",
    transform: "translate(-50)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_510_",
    d: "M51.545,34H72.15A1.545,1.545,0,0,0,73.7,32.453V14.939a1.545,1.545,0,0,0-1.545-1.545H70.605V8.757a8.757,8.757,0,1,0-17.514,0v4.636H51.545A1.545,1.545,0,0,0,50,14.939V32.453A1.545,1.545,0,0,0,51.545,34Zm11.848-9.789v2.062a1.545,1.545,0,1,1-3.091,0V24.209a2.576,2.576,0,1,1,3.091,0ZM56.182,8.757a5.666,5.666,0,1,1,11.333,0v4.636H56.182Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.06ebc65ff4157335051d9f8510caa4a3.svg";
export { ForwardRef as ReactComponent };